import { atom } from 'recoil'

export const globalIsLoadingAtom = atom<boolean>({
    key: 'globalIsLoadingAtom',
    default: false,
})
